var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBedaHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_343_1819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.779 9.18867H13.4968V0.847656H7.39111V9.18867H0.106934V14.2974H7.39111V22.6364H13.4968V14.2974H20.779V9.18867Z",
    fill: "url(#paint0_radial_343_1819)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_343_1819",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(15.0141 16.3632 -42.3721 8.14539 2.82528 3.82805)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#010A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081939"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_343_1819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.6721,
    height: 21.7887,
    fill: "white",
    transform: "translate(0.106934 0.847656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedaHealth);
export default __webpack_public_path__ + "static/media/Beda-Health.15c7294950346c4c480c2c93f6652010.svg";
export { ForwardRef as ReactComponent };